export function formatPrice(price: number, options?: { withoutSpace?: boolean }): string {
    // I challenge you to do something better that works for 4.515
    const roundPrice = +(Math.round(Number(price.toString() + 'e+2')) + 'e-2');
    const [euros, cents] = roundPrice.toString().split('.');
    const formattedCents = cents?.length === 2 ? cents : `${cents}0`;

    return `${euros}${cents ? `,${formattedCents}` : ''}${options?.withoutSpace ? '' : '\xa0'}€`;
}
